import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import BoxInfo from "./Info/BoxInfo";
import { useParams } from "react-router-dom";
import { useMember } from "./provider";
import TableInfo from "./Info/TableInfo";

const MemberDetails = () => {
  let params = useParams();
  const id = params.id;
  const [reload, setReload] = useState(false);
  const {
    state: { selected: member },
    fetchOne: fetchMember,
  } = useMember();

  useEffect(() => {
    fetchMember(id);
  }, [id, fetchMember]);
  if (!member) return;

  return (
    <>
      <Typography variant="Poster" component="h4">
        Member Details
      </Typography>
      <BoxInfo reload={reload} setReload={setReload} member={member} />
      <TableInfo reload={reload} member={member} />
    </>
  );
};

export default React.memo(MemberDetails);
